import { DownloadIcon } from '@panwds/icons';
import { Button, Tooltip } from '@panwds/react-ui';
import React from 'react';
import { downloadCSV } from '../../utils/downloadTable.js';
export function DownloadButton({ fileName, tableInstance, tooltipLabel = 'Download the current table data', icon = React.createElement(DownloadIcon, { size: "md" }), children }) {
    const disabled = tableInstance.rows.length === 0;
    return (React.createElement(Tooltip, { label: tooltipLabel },
        React.createElement(Button, { "aria-label": "Download", disabled: disabled, appearance: "tertiary", icon: icon, onClick: () => {
                const fn = typeof fileName === 'function' ? fileName() : fileName;
                downloadCSV(tableInstance, fn);
            } }, children)));
}
//# sourceMappingURL=DownloadButton.js.map